<template>
  <div class="booking-card-container" :style="bookingCardStyles">
    <div class="booking-card">
      <div>
        <h1>{{ booking.title }}</h1>
        <h2>{{ booking.description }}</h2>
      </div>
      <div class="organizer-container">
        <h3>Organizer: {{ email }}</h3>
        <span>{{ schedule }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BookingMixins from '../../../mixins/booking-mixins';

export default {
  mixins: [BookingMixins],

  computed: {
    ...mapState({
      backgroundColor: state => state.space.calendar_color,
    }),

    bookingCardStyles() {
      return {
        backgroundColor: this.backgroundColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
div.booking-card-container {
  box-sizing: border-box;
  color: #fff;
  height: 100%;
  border-radius: 24px;
  padding: 30px;
}

h1 {
  font-size: 56px;
  font-weight: bold;
  letter-spacing: -0.47px;
  line-height: 68px;
  text-shadow: 9px 4px rgba(0,0,0,0.04);
}

h2 {
  font-size: 22px;
  letter-spacing: -0.19px;
  line-height: 27px;
}

h3 {
  font-size: 17px;
  letter-spacing: -0.14px;
  line-height: 20px;
  text-shadow: 9px 4px rgba(0,0,0,0.03);
}

.booking-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .organizer-container {
    display: flex;
    justify-content: space-between;

    span {
      font-size: 29px;
      font-weight: bold;
      letter-spacing: -0.25px;
      line-height: 35px;
      text-align: right;
      text-shadow: 9px 4px rgba(0,0,0,0.03);
    }
  }
}

@media only screen and (max-width: 720px) {
  .booking-card {
    .organizer-container {
      span {
        font-size: 4vh;
        line-height: 1em;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Booking/Card/Item.vue